import { combineReducers } from 'redux';

import { orderSummary } from './orderSummary';
import { analytics } from './analytics';
import { statuses } from './statuses';
import { modal } from './modal';
import { caching } from './caching';
import { aemProps } from './aemProps';
import { amendAppointment } from './amendAppointment';

export const mainReducer = combineReducers({
  orderSummary,
  statuses,
  modal,
  analytics,
  caching,
  aemProps,
  amendAppointment,
});
